import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { queryParamToString } from '~/logic/query-param';

type DrawerState = {
  opened: boolean;
  id?: string;
};

// `keysToRemoveOnClose` are keys that should be removed when the drawer is closed, like attemptId for the test attempt switcher
export function useDrawerState({
  queryKey,
  keysToRemoveOnClose = [],
}: {
  queryKey: string;
  keysToRemoveOnClose?: string[];
}) {
  const router = useRouter();
  const drawerId = queryParamToString(router.query[queryKey]);

  const [drawerState, setDrawerState] = useState<DrawerState>({
    opened: false,
    id: undefined,
  });

  useEffect(() => {
    setDrawerState((prev) => ({
      ...prev,
      id: drawerId,
      opened: !!drawerId,
    }));
  }, [drawerId]);

  const closeDrawer = () => {
    const keysToRemove = [queryKey, ...keysToRemoveOnClose];
    const queryWithoutDrawer = Object.fromEntries(
      Object.entries(router.query).filter(([key]) => !keysToRemove.includes(key)),
    );

    void router.push({
      pathname: router.pathname,
      query: queryWithoutDrawer,
    });
  };

  return {
    id: drawerState.id,
    opened: drawerState.opened,
    closeDrawer,
  };
}
